import axios from 'axios';

// API 기본 설정
// Capacitor 네이티브 앱: hostname이 localhost이므로 풀 URL 필요
const isCapacitor = window.Capacitor?.isNativePlatform?.() ?? false;
const API_BASE_URL = process.env.NODE_ENV === 'production'
  ? (window.location.hostname === 'acornbank.duckdns.org' || isCapacitor
      ? 'https://acornbank.duckdns.org/api/v0'
      : '/api/v0')
  : 'http://localhost:3001/api/v0';

// Axios 인스턴스 생성
const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// 요청 인터셉터 - 토큰 자동 추가
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 응답 인터셉터 - 에러 처리
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      // 인증 실패 시 토큰 제거 및 로그인 페이지로 리다이렉트
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.location.href = '/parent/login';
    }
    return Promise.reject(error);
  }
);

export { API_BASE_URL };
export default api;
